import AuthService from "@/services/AuthService";

export const namespaced = true;

export const state = {
  me: {},
};

export const mutations = {
  setMe(state, user) {
    if (user) {
      user.is_auth = true;
      localStorage.setItem("me", JSON.stringify(user));
    } else {
      localStorage.clear();
    }
    state.me = Object.assign({}, user);
  },
};

export const actions = {
  signIn({ commit, dispatch }, { userId, password }) {
    return AuthService.signIn(userId, password)
      .then((res) => {
        const { data } = res.data;
        data.is_auth = true;
        commit("setMe", data);
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  signOut({ commit }) {
    return AuthService.signOut().finally(commit("setMe", null));
  },
  setMe({ commit }, user) {
    commit("setMe", user);
  },
};

export const getters = {
  getLoggedInUser: () => () => {
    const me = localStorage.getItem("me");
    if (me) {
      const { name, role, platoon_id, user_id } = JSON.parse(me);
      return { name: name, role: role, platoon_id: platoon_id , user_id:  user_id};
    }
    return null;
  },
};
